import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  TextField,
  Button,
  Typography,
  Alert,
} from '@mui/material';
import {
  AuthContainer,
  Logo,
  AuthBox,
  FormContainer,
  LinkContainer,
} from '../../styles/Auth.styles';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error('Error parsing response:', jsonError);
        throw new Error('Invalid server response. Please try again later.');
      }

      if (!response.ok) {
        if (data && data.error) {
          throw new Error(data.error);
        }
        throw new Error('Failed to process request. Please try again.');
      }

      setSuccess(true);
      setEmail(''); // Clear email after successful submission
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContainer>
      <Logo
        src="/images/eci_logo_color.svg"
        alt="ECI Logo"
      />
      <AuthBox>
        <Typography component="h1" variant="h5" align="center" gutterBottom>
          Reset your password
        </Typography>
        <FormContainer component="form" onSubmit={handleSubmit}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Password reset instructions have been sent to your email.
            </Alert>
          )}
          <TextField
            margin="normal"
            required
            fullWidth
            label="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Reset your password'}
          </Button>
          <LinkContainer>
            <Link to="/login">
              Back to login
            </Link>
          </LinkContainer>
        </FormContainer>
      </AuthBox>
    </AuthContainer>
  );
};

export default ForgotPassword;
